import styled from "styled-components";

const Label = styled.label`
	font-size: 14px;
	line-height: 20px;
	color: #6b7c8f;
`;

export default Label;
